<template lang="pug">
  v-content.custom-content
    // Snackbar
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    //Rtc desktop
    vue-draggable-resizable(v-if="dialogRTC && !isMobile" :w="768" :h="390" :lock-aspect-ratio="true" :minHeight="390" :minWidth="768" :maxHeight="390" :maxWidth="768" :z="9999" :parent="true" style="border: none")
      web-rtc(@closeRTC="closeDialog('webRTC')")
    // RTC mobile
    v-dialog(v-if="dialogRTC && isMobile" v-model="dialogRTC" fullscreen fixed)
      web-rtc(@closeRTC="closeDialog('webRTC')")
    // Payment wizard modal
    v-dialog(v-model='paymentWizDialog' v-if="paymentWizDialog" transition="dialog-bottom-transition" :fullscreen='isMobile'  persistent max-width='890px').pa-5
      payment-wizzard(@close="closeDialog('paymentWizDialog')" @closePayment="closeDialogPayment").ma-2
    //- Login
    v-dialog(overlay-color='secondary__blue'  overlay-opacity='0.7' max-width="500" v-model="loginDialog" v-if="loginDialog")
      login(userType="Buyer" @close="closeDialog('login')" @switchDialog="openDialog('register')")
    //- Register
    v-dialog(  overlay-color='secondary__blue' overlay-opacity='0.7' max-width="500" v-model="registerDialog" v-if="registerDialog").ma-0
      register(userType="Buyer" @close="closeDialog('register')" @switchDialog="openDialog('login')")
    router-view
    <!--<dashboard-core-footer />-->

</template>

<script>
  export default {
    name: 'MarketplaceCoreView',

    components: {
      login: () => import('@/views/pages/Login'),
      register: () => import('@/views/pages/Register'),
      WebRtc: () => import('@/views/marketplace/components/core/VideoChat'),
      PaymentWizzard: () => import('@/views/marketplace/components/PaymentWizzard'),
      // DashboardCoreFooter: () => import('./Footer'),
    },
    data () {
      return {
        loginDialog: false,
        registerDialog: false,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      currentDialog () {
        return this.$store.state.dialogs.currentItem
      },
      dialogRTC () {
        return this.$store.state.dialogs.webRTC
      },
      paymentWizDialog () {
        return this.$store.state.dialogs.paymentWizDialog
      },
    },
    watch: {
      currentDialog (newVal, oldVal) {
        // console.log(newVal)
        newVal === 'login' ? this.loginDialog = true : this.loginDialog = false
        newVal === 'register' ? this.registerDialog = true : this.registerDialog = false
      },
    },
    methods: {
      openDialog (dialog) {
        this.$store.dispatch('dialogs/openDialog', dialog).then(function () {
          // console.log('dialog set on : ' + dialog)
        })
      },
      closeDialog (dialog) {
        // console.log('close')
        this.$store.dispatch('dialogs/closeDialog', dialog).then(function () {
          // dialogs closed
        })
      },
      closeDialogPayment () {
        this.$store.dispatch('dialogs/closeDialog', 'paymentWizDialog')
        /* this.snackbar.snackbar = true
        this.snackbar.color = 'success'
        this.snackbar.text = 'Orden procesada.' */
      },
    },
  }
</script>
<style lang="scss">
  .custom-content{
    width: 100% !important;
    margin: 0 auto;
    background-color: transparent !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .draggable{
    &__border{
      border: none;
    }
  }
</style>
